/**
 * React Query Provider
 *
 * Wraps the application with QueryClientProvider for data fetching.
 * Includes DevTools in development mode.
 */

import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./queryClient";

interface QueryProviderProps {
  children: React.ReactNode;
}

const isDev = process.env.NODE_ENV === "development";

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {isDev && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      )}
    </QueryClientProvider>
  );
};
